export default function TrustBar() {
  const items = [
    { icon: 'ri-refresh-line', label: 'Updated Weekly', desc: 'Fresh content every 7 days' },
    { icon: 'ri-stack-line', label: '10,000+ Products', desc: 'Across all categories' },
    { icon: 'ri-shield-check-line', label: 'Safe Shopping', desc: 'Verified buying guides' },
    { icon: 'ri-global-line', label: 'Free Access', desc: 'No registration needed' },
  ];

  return (
    <section className="relative py-12 md:py-16 px-6 md:px-10 lg:px-16 bg-background-50 border-y border-background-200/60">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {items.map((item) => (
            <div key={item.label} className="flex flex-col items-center text-center gap-2">
              <span className="w-12 h-12 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600 mb-1">
                <i className={`${item.icon} text-xl`}></i>
              </span>
              <span className="text-sm md:text-base font-semibold text-foreground-900 whitespace-nowrap">
                {item.label}
              </span>
              <span className="text-xs text-foreground-500">
                {item.desc}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}